import React from 'react';
import { Helmet } from 'react-helmet';
import { PlannerMenu } from '../oldPlanner/PlannerMenu';
import { bemComponent } from './bemComponent';
import { Loader } from '../../components/Loader/Loader';
import './PreferredAreas.scss';
import { Region } from 'types/orderTypes';
import { usePreferredAreaData } from 'hooks/usePreferredAreaData';
import { PreferredAreasWrapper } from './PreferredAreasWrapper';

interface PreferredAreasProps {
  region: Region;
}

export const PreferredAreas = ({ region, ...props }: PreferredAreasProps) => {
  const bem = bemComponent('preferred-areas');

  const preferredAreaData = usePreferredAreaData();

  return (
    <>
      <Helmet>
        <title>Preferred Areas</title>
      </Helmet>
      <PlannerMenu />

      <div className={bem.className}>
        {preferredAreaData.isFetchingCourierList ||
        preferredAreaData.isFetchingSelectedCourier ? (
          <div className={bem.element('spinner')}>
            <Loader type="spinner" size="xxl" />
          </div>
        ) : (
          <PreferredAreasWrapper
            region={region}
            courierList={preferredAreaData.courierList}
            selectedCourier={preferredAreaData.selectedCourier}
            onChangeSelectedCourier={preferredAreaData.onChangeSelectedCourier}
          />
        )}
      </div>
    </>
  );
};
